// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: 'HitPaw Online Ultimate',
  freeTimesLimitTitle: 'Uji coba gratis telah habis hari ini.',
  fileSizeLimitTitle:
    'Ukuran file tidak boleh melebihi 20MB dalam versi gratis.',
  freeImgCutoutTimesLimitTitle:
    'Kesempatan uji coba hari ini untuk menghapus latar belakang telah habis, harap tingkatkan ke Pro untuk mengakses semua fitur premium',
  total: 'Total',
  enterCode: 'Memasukkan kode',
  signUpToPurchaseBtn: 'Daftar untuk Membeli',
  goPurchseBtn: 'Pergi ke Pembelian',
  saveTips: 'Hemat Hingga {{num}}%',
  discount: 'Diskon',
  priceWeek: '$9,99',
  priceMonth: '$7,49',
  priceYear: '$3,75',
  billedMonth: '$29,99 Ditagih Bulanan',
  billedYear: '$179,99 Ditagih Setiap Tahun',
  week: 'Minggu',
  weekly: 'Mingguan',
  monthly: 'Bulanan',
  yearly: 'Tahunan',
  AlreadySubscribe: 'Sudah berlangganan?',
  vipTips1: 'Tidak ada batasan ukuran file',
  vipTips2: 'Tidak ada batasan jumlah file yang diproses',
  vipTips3: 'Ubah latar belakang gambar tanpa batas',
  vipTips4: 'Akses ke semua alat gratis & fitur premium',
  purchaseTips: 'Perbarui secara otomatis dan batalkan kapan saja.',
  tips: 'Kiat:',
  promoCodeInvalidTips: 'Kode promo Anda tidak valid',
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
